<template>
    <div>
       <el-row>
          <el-col :lg="22" :offset="2">
              推薦人清單:
              <el-table
                  :data="referrer.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                  empty-text="暫無數據"
                  style="width: 100%"
                  
                  >
                  <el-table-column label="日期" prop="date">
                      
                  </el-table-column>
                  <el-table-column
                      prop="member_name"
                      label="姓名"
                      >
                  </el-table-column>
                  <el-table-column label="電話" prop="phone" >
                    
                  </el-table-column>
                  
              </el-table>
                  <el-pagination
        background
        layout="prev, pager, next"
        :total="total1"
        @current-change="current_change"
        >
      </el-pagination>
          </el-col>
      </el-row>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
     name: 'referrer',
        props: {
            memberKey: String
        },
        data() {
            return {
                referrer: [],

                          total1: 0,
                 currentPage:1,
                pagesize: 10,
            }
        },
         computed: mapGetters(["getMemberReferrer"]),
        methods: {
            ...mapActions(["fetchMemberReferrer"]),
            async fetch(){
                  const data =await {_key: this.memberKey}
              await this.$store.dispatch('fetchMemberReferrer', data)
              this.referrer = this.getMemberReferrer
            },
              current_change: function (currentPage) {
                this.currentPage = currentPage;
            }
        },
        mounted() {
            this.fetch()
        },
}
</script>